import React, {useState, useRef} from 'react';
import {Link as RouterLink, Route, Routes, useNavigate, useParams, useLocation} from 'react-router-dom';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faExternalLinkAlt} from '@fortawesome/free-solid-svg-icons';
import {Element, scroller} from 'react-scroll';
import {CSSTransition, TransitionGroup} from 'react-transition-group';
import EducationLevelSelection from "../EducationLevelSelection/EducationLevelSelection";
import {educationLevels} from '../EducationLevelSelection/EducationLevelSelection';
import './DocumentLinksPage.css';
import {baseMenuItems} from '../../utils/consts/menuConfig'

const parseSelectedLevelsId = (selectedLevelId) => {
    return (selectedLevelId === '1' || selectedLevelId === '2')
        ? [1, 2]
        : [Number(selectedLevelId)]
}

const handleBachelorLinkClick = (event, selectedLevelsId) => {
    event.preventDefault();
    localStorage.setItem('selectedLevelsId', JSON.stringify(selectedLevelsId));

    const currentUrl = window.location.pathname;

    const isHomePage = currentUrl === '/' || currentUrl === '';

    if (isHomePage) {
        scroller.scrollTo('bachelor', {
            duration: 500,
            delay: 0,
            smooth: 'easeInOutQuart',
            offset: -120,
        });

        const cardProgramElements = document.querySelectorAll('.card-program');

        cardProgramElements.forEach(element => {
            const showIds = element.getAttribute('data-show-ids').split(',').map(Number);

            const isMatch = selectedLevelsId.every(id => showIds.includes(id));

            if (isMatch) {
                element.querySelector('.card-program__link').click();
            }
        });
    } else {
        window.open('/?scrollTo=bachelor', '_self');
    }
};

const DocumentLinksPage = () => {
    const navigate = useNavigate();
    const {level} = useParams();
    const location = useLocation();
    const [containerHeight, setContainerHeight] = useState('auto');
    const containerRef = useRef(null);

    const validLevels = educationLevels.map(l => l.key);
    if (!level || !validLevels.includes(level)) {
        return <EducationLevelSelection/>;
    }

    const appsPath = `./${level}`;

    const App1Component = require(`${appsPath}/App1`).default;
    const App2Component = require(`${appsPath}/App2`).default;
    const App3Component = require(`${appsPath}/App3`).default;
    const App4Component = require(`${appsPath}/App4`).default;
    const App5Component = require(`${appsPath}/App5`).default;
    const App6Component = require(`${appsPath}/App6`).default;
    const App7Component = require(`${appsPath}/App7`).default;
    const App8Component = require(`./App8`).default;
    const App9Component = require(`./App9`).default;

    const handleScrollLinkClick = (path) => {
        navigate(`/documents/${level}/${path}`);
    };

    const contentContainer = document.querySelector('.DocumentLinksPage__content-container');

    if (contentContainer) {
        scroller.scrollTo('DocumentLinksPage__information-container', {
            duration: 500,
            delay: 0,
            smooth: 'easeInOutQuart',
            offset: -120,
        });
    }

    const selectedLevel = educationLevels.find(l => l.key === level);
    const selectedLevelsId = parseSelectedLevelsId(selectedLevel._id);

    const filteredItems = baseMenuItems
        .filter(item => !item.excludeFor || !item.excludeFor.includes(selectedLevel.key))
        .map(item => ({
            ...item,
            href: typeof item.href === 'function' ? item.href(selectedLevel) : item.href
        }));

    return (
        <div className="DocumentLinksPage__container">
            <h1>{selectedLevel.label}</h1>
            <ul className="DocumentLinksPage__list">
                {filteredItems.map((item, index) => (
                    <li key={index}>
                        {item.isExternal ? (
                            item.changeSelectedProgram ? (
                                <a href="#" onClick={(event) => handleBachelorLinkClick(event, selectedLevelsId)}>
                                    {item.label}
                                    <FontAwesomeIcon icon={faExternalLinkAlt} className="external-link-icon"/>
                                </a>
                            ) : (
                                <a href={item.href} target="_blank" rel="noopener noreferrer">
                                    {item.label}
                                    <FontAwesomeIcon icon={faExternalLinkAlt} className="external-link-icon"/>
                                </a>
                            )
                        ) : (
                            <RouterLink to={item.key} onClick={() => handleScrollLinkClick(item.key)}>
                                {item.label}
                            </RouterLink>
                        )}
                    </li>
                ))}
            </ul>
            <Element name="DocumentLinksPage__information-container"
                     className="DocumentLinksPage__information-container">
                <div style={{transition: 'height 500ms ease', height: containerHeight}} ref={containerRef}>
                    <TransitionGroup>
                        <CSSTransition
                            key={location.key}
                            classNames="fade"
                            timeout={500}
                            onEntering={() => {
                                if (containerRef.current) {
                                    setContainerHeight(containerRef.current.clientHeight);
                                }
                            }}
                            onEntered={() => setContainerHeight('auto')}
                        >
                            <Routes location={location}>
                                <Route path={`app1`} element={<App1Component/>}/>
                                <Route path={`app2`} element={<App2Component/>}/>
                                <Route path={`app3`} element={<App3Component/>}/>
                                <Route path={`app4`} element={<App4Component/>}/>
                                <Route path={`app5`} element={<App5Component/>}/>
                                <Route path={`app6`} element={<App6Component/>}/>
                                <Route path={`app7`} element={<App7Component/>}/>
                                <Route path={`app8`} element={<App8Component selectedLevelsId={selectedLevelsId}/>}/>
                                <Route path={`app9`} element={<App9Component/>}/>
                            </Routes>
                        </CSSTransition>
                    </TransitionGroup>
                </div>
            </Element>
        </div>
    );
};

export {parseSelectedLevelsId, handleBachelorLinkClick};
export default DocumentLinksPage;